import type { stacks } from "@dropbox/api-v2-client";
import { useMirageAnalyticsContext } from "@mirage/analytics/AnalyticsProvider";
import type { PAPEvent } from "@mirage/analytics/events/base/event";
import { stackDerivePAPProps } from "@mirage/service-stacks";
import { activeStackAtom } from "@mirage/stacks/atoms";
import { useAtomValue } from "jotai";
import { useCallback } from "react";

export const useReportStackPapEvent = (stack?: stacks.Stack | null) => {
  const { reportPapEvent } = useMirageAnalyticsContext();
  const activeStack = useAtomValue(activeStackAtom);
  const stackToReport = stack ?? activeStack;

  const reportStackPapEvent = useCallback(
    async (event: PAPEvent) => {
      if (stackToReport && stackToReport.namespace_id) {
        reportPapEvent({
          ...event,
          properties: {
            ...stackDerivePAPProps(stackToReport),
            featureLine: "stacks",
            ...event.properties,
          },
        });
      }
    },
    [reportPapEvent, stackToReport],
  );

  return reportStackPapEvent;
};
